import { Component, OnInit } from '@angular/core';
import { finalize, Observable } from 'rxjs';
import { ReportsService } from '../../services/reports.service';
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { ReportBuilderComponent } from "@app/modules/custom-reports/components/report-builder/report-builder.component";
import { Router } from "@angular/router";
import { features } from '@app/consts/features';
import { CustomReportsService } from '@app/modules/custom-reports/services/reports.service';

@Component({
  selector: 'app-reports-rectangle-display-list',
  templateUrl: './reports-rectangle-display-list.component.html',
  styleUrls: ['./reports-rectangle-display-list.component.scss']
})
export class ReportsRectangleDisplayListComponent implements OnInit {
  reports$: Observable<any>;
  hardcodedReports: any[] = []
  public displayedColumns: string[] = ['name'];
  public features = features;
  isLoading: boolean;

  constructor(
    private reportsService: ReportsService,
    private dialog: MatDialog,
    private router: Router,
    private customReportsService: CustomReportsService,
  ) {
    this.reports$ = reportsService.getReports();
    this.getResports();
  }

  ngOnInit(): void {
  }

  getResports() {
    this.isLoading = true;
    this.reportsService.getReports()
      .pipe(
        finalize(() => {
          this.isLoading = false;
        })
      )
      .subscribe(
        res => {
          console.log(res);
          this.hardcodedReports = res;
          this.getCustomResports();
        }
      );
  }

  getCustomResports() {
    this.isLoading = true;
    this.customReportsService.getNewReports(100, 0, `Type.Id = "test-type"`)
      .pipe(
        finalize(() => {
          this.isLoading = false;
        })
      )
      .subscribe(
        res => {
          res.data.forEach((report: any) => {
            let index = this.hardcodedReports.findIndex((r: any) => r.id === report.id);
            if (index !== -1) {
              this.hardcodedReports[index].name = report.name;
            }
          });
        });
  }

  showMenu(id) {
    return id === 'ReportOrganizationalChart' || id === 'ReportPositionChart';
  }

  goToEditReport(id: string) {
    this.router.navigate([`Reports/Builder/Edit/${id}`]);
  }

  openNewReportDialog() {
    this.router.navigate(['Reports/Builder']);

    // const dialogConfig = new MatDialogConfig();
    //
    // dialogConfig.disableClose = true;
    // dialogConfig.autoFocus = true;
    // dialogConfig.minWidth = 1200;
    //
    // const dialogRef = this.dialog.open(ReportBuilderComponent, dialogConfig);
  }
}